var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FA6E58",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm0-1.6c5.744 0 10.4-4.656 10.4-10.4 0-5.744-4.656-10.4-10.4-10.4C6.256 1.6 1.6 6.256 1.6 12c0 5.744 4.656 10.4 10.4 10.4z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.2 4.8)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.88,
    cy: 12.08,
    r: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.6,
    height: 9.6,
    rx: 0.8
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErro);
export default __webpack_public_path__ + "static/media/erro.ce447afc9e0aa57f57d962fdb7bb71b0.svg";
export { ForwardRef as ReactComponent };